import React from 'react'
import { IconButton } from 'transfix-ui/components/'
import { Box, Button, makeStyles, Typography } from 'transfix-ui/core'
import { IConfigurableBuilder } from 'types/graphqlTypes'
import { ClearIcon } from 'transfix-icons'

interface IEDIOutboundHeaderProps {
  onClearBuilderClick: () => void
  onLoadBuilderClick: () => void
  onBuilderWarningsClick: () => void
  selectedBuilder: IConfigurableBuilder | null
}

const useStyles = makeStyles(theme => ({
  editor: {
    borderRight: '1px solid',
    '& .cm-content': {
      border: '1px solid',
      borderRight: 'none',
    },
    '& .cm-lineNumbers': {
      minWidth: 33,
    },
    '& .cm-line::selection': {
      backgroundColor: '#d9d9d9 !important',
    },
  },
  column: {
    flex: 5,
  },
  columnSmall: {
    flex: 3,
  },
  columnLarge: {
    flex: 7,
  },
  topNav: {
    marginBottom: theme.spacing(1),
    minHeight: 72,
    boxShadow: '0 1px 2px rgb(0 0 0 / 15%)',
  },
  loadBuildersButton: {
    marginLeft: theme.spacing(1),
  },
  loadedBuilderText: {
    marginRight: theme.spacing(1),
  },
}))

export const EDIOutboundHeader = ({
  onBuilderWarningsClick,
  onClearBuilderClick,
  onLoadBuilderClick,
  selectedBuilder,
}: IEDIOutboundHeaderProps) => {
  const classes = useStyles()

  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      flexWrap='wrap'
      className={classes.topNav}
      paddingX={2}>
      <Box
        display='flex'
        flexDirection='row'
        justifyContent='space-between'
        flexWrap='wrap'
        flexGrow={1}>
        <Typography variant='h3'>EDI Self Service Outbound</Typography>
        <Box display='flex' alignItems='center'>
          {selectedBuilder && (
            <>
              <Typography className={classes.loadedBuilderText} variant='subtitle2'>
                Loaded Builder: {selectedBuilder.name}
              </Typography>
              <IconButton
                Icon={ClearIcon}
                color='secondary'
                onClick={onClearBuilderClick}
                size='large'
              />
            </>
          )}
          <Button className={classes.loadBuildersButton} onClick={onLoadBuilderClick}>
            Load Builder
          </Button>
          {selectedBuilder && (
            <>
              <Button className={classes.loadBuildersButton} onClick={onBuilderWarningsClick}>
                Builder Warnings
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Box>
  )
}
